import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { ShieldX, Mail } from 'lucide-react';

export default function Blocked() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-8">
      <Card className="max-w-md w-full border-0 shadow-xl">
        <CardContent className="pt-12 pb-8 px-8 text-center">
          <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <ShieldX className="w-10 h-10 text-red-600" />
          </div>
          
          <h1 className="text-2xl font-bold mb-3" data-testid="blocked-title">
            Acesso Bloqueado
          </h1>
          
          <p className="text-muted-foreground mb-8 leading-relaxed">
            Sua conta foi bloqueada pelo administrador. Se você acredita que isso 
            foi um erro, entre em contato com o suporte.
          </p>
          
          <div className="bg-red-50 border border-red-100 rounded-2xl p-6 mb-8">
            <div className="flex items-center gap-3 text-left">
              <div className="w-10 h-10 bg-red-100 rounded-xl flex items-center justify-center flex-shrink-0">
                <Mail className="w-5 h-5 text-red-600" />
              </div>
              <div>
                <p className="font-medium text-sm text-red-800">Precisa de ajuda?</p>
                <p className="text-xs text-red-600">
                  Entre em contato com o administrador para mais informações.
                </p>
              </div>
            </div>
          </div>
          
          <Link to="/login" data-testid="back-to-login">
            <Button variant="outline" className="w-full h-11 rounded-full">
              Voltar ao Login
            </Button>
          </Link>
        </CardContent>
      </Card>
    </div>
  );
}
